// extracted by mini-css-extract-plugin
export default {"select":"styles_select__atvwS","withValue":"styles_withValue__pi11c","inline":"styles_inline__iTJR-"};